module.exports = __webpack_public_path__ + "img/icon_symbolmutel_color.a3a6ee56.svg";